import { styled } from '@mui/material/styles';
import { Row } from 'components/SectionedTable';
import { ConsiderationType } from '../../../types';
import { dateToLabel } from 'further-ui/utils';

const BoldText = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
}));

type Props = {
  row: Row;
  investmentDate?: Date;
};

const RenderInvestmentDateCell: React.FC<Props> = ({ row, investmentDate }) => {
  if (row.key === ConsiderationType.UnitsRealised) {
    return (
      <BoldText>{investmentDate ? dateToLabel(investmentDate) : '-'}</BoldText>
    );
  }
  return <span></span>;
};

export default RenderInvestmentDateCell;
